import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AuthService from "./services/authService";
import "./index.css";

const authService = new AuthService();
authService.loadAuthModule();
console.log("Auth module loaded");

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById("root")
);
